<template>
	<V2Layout>
		<div class="v2-agd">
			<OriginalComponent v-bind="routeProps" :key="$route.fullPath" />
		</div>
	</V2Layout>
</template>

<script>
import V2Layout from '@/layouts/V2Layout';
import OriginalComponent from '@/pages/agency/details.vue';

export default {
	name: 'V2AgencyDetails',
	components: { V2Layout, OriginalComponent },
	computed: {
		routeProps() {
			return {
				id: ~~this.$route.params.id,
				side: 'dsp',
				resource: 'agency',
				isSspDspEditPage: true,
				...this.$attrs,
			};
		},
	},
};
</script>

<style lang="sass" scoped>
@import '~@/assets/styles/v2-tokens.sass'

.v2-agd
	font-family: $v2-font
	max-width: 900px
	width: 100%

.v2-agd ::v-deep

	// ── Reset v1 layout ──────────────────
	.layout-full_width,
	.page-details
		margin: 0 !important
		padding: 0 !important
		max-width: none !important

		> *
			margin-left: 0 !important
			margin-right: 0 !important
			max-width: 100% !important

	// ── Page title (hide) ────────────────
	.page-title
		display: none !important

	// ══════════════════════════════════════
	// 1. ACTION BAR (Back / Reset / Apply)
	// ══════════════════════════════════════
	.top-panel
		display: flex
		justify-content: space-between
		align-items: center
		margin-bottom: 16px

		.left .nice-button
			background: transparent !important
			border: none !important
			color: $v2-text-muted !important
			font-size: 12px !important
			padding: 4px 8px !important
			min-height: auto !important
			margin-left: -8px

			&:hover
				color: $v2-text !important

	.top-panel__buttons
		display: flex
		gap: 8px

		.nice-button
			height: 32px !important
			min-height: 32px !important
			font-size: 12px !important
			padding: 0 14px !important
			border-radius: 8px !important
			font-weight: 600 !important
			gap: 6px !important

	// ══════════════════════════════════════
	// 2. AGENCY HEADER CARD
	// ══════════════════════════════════════
	.header
		margin-bottom: 16px

		.details-header
			background: $v2-card-bg
			border: 1px solid $v2-border
			border-radius: 16px
			padding: 20px 24px
			box-shadow: $v2-shadow-card
			display: flex
			align-items: center
			gap: 16px

		.details-header__avatar
			width: 56px !important
			height: 56px !important
			border-radius: 16px !important
			font-size: 18px !important
			font-weight: 700 !important
			border: none !important
			flex-shrink: 0

		.details-header__info
			flex: 1
			min-width: 0

		.details-header__name
			font-family: $v2-font !important
			font-size: 20px !important
			font-weight: 700 !important
			color: $v2-text !important
			line-height: 1.3

		.details-header__comment
			font-family: $v2-font !important
			font-size: 12px !important
			color: $v2-text-muted !important
			margin-top: 2px

		// Name/comment edit inputs
		.details-header input
			font-family: $v2-font
			border-radius: 8px
			border-color: rgba($v2-teal, 0.4)
			font-size: 14px
			padding: 6px 10px

	// ══════════════════════════════════════
	// 3. CONTACT INFORMATION CARD
	// ══════════════════════════════════════
	.agency-card
		background: $v2-card-bg
		border: 1px solid $v2-border
		border-radius: 16px
		padding: 20px 24px
		margin-bottom: 16px
		box-shadow: $v2-shadow-card

	// Labels inside agency card
	.nice-label
		font-family: $v2-font !important
		font-size: 11px !important
		font-weight: 600 !important
		text-transform: uppercase !important
		letter-spacing: 0.06em !important
		color: $v2-text-muted !important

	// Values
	.agency-card__value,
	.nice-input .ni_input--input
		font-family: $v2-font
		font-size: 14px
		color: $v2-text

	// ══════════════════════════════════════
	// 4. TABS CARD (Networks / Users)
	// ══════════════════════════════════════
	.nice-tabs
		background: $v2-card-bg
		border: 1px solid $v2-border
		border-radius: 16px
		box-shadow: $v2-shadow-card
		overflow: hidden

		// Tab bar
		.ni_tabs--tabs
			border-bottom: 1px solid $v2-border
			padding: 12px 24px 0
			background: transparent
			gap: 24px

		.ni_tabs--tab
			font-family: $v2-font
			font-size: 12px
			font-weight: 600
			color: $v2-text-muted
			padding: 0 0 12px
			border: none
			border-bottom: 2px solid transparent
			background: transparent
			transition: all 0.15s

			&:hover
				color: $v2-text

			&.ni_tabs--tab__active
				color: $v2-teal
				border-bottom-color: $v2-teal

		// Tab content
		.ni_tabs--content
			padding: 0

		.ni_tabs--content > div
			padding: 20px 24px

	// ── Search inside tabs ────────────────
	.search-input-wrapper,
	.platforms-list > div:first-child
		margin-bottom: 16px

		input
			font-family: $v2-font
			font-size: 12px
			border: 1px solid $v2-border
			border-radius: 10px
			padding: 8px 12px 8px 32px
			background: #f8f9fb
			max-width: 280px
			width: 100%

			&:focus
				border-color: $v2-teal
				outline: none

	// ══════════════════════════════════════
	// TABLES (Networks, Users, etc.)
	// ══════════════════════════════════════
	.nice-table,
	table
		width: 100%
		border-collapse: collapse
		font-size: 12px

		th
			font-family: $v2-font
			font-size: 11px
			font-weight: 600
			text-transform: uppercase
			letter-spacing: 0.06em
			color: $v2-text-muted
			padding: 10px 16px
			border-bottom: 1px solid $v2-border
			background: transparent
			text-align: left

		td
			font-family: $v2-font
			font-size: 13px
			color: $v2-text
			padding: 12px 16px
			border-bottom: 1px solid rgba($v2-border, 0.5)

		tr:last-child td
			border-bottom: none

		tr:hover td
			background: rgba($v2-teal, 0.02)

	// ── Access badges (Has Access / No Access) ──
	.ni_action_list--status
		.nice-button
			border-radius: 20px !important
			padding: 3px 12px !important
			min-height: auto !important
			font-size: 11px !important
			font-weight: 600 !important
			border: none !important

	// ── Status text ──────────────────────
	.status-available
		color: darken($v2-green, 10%)
		font-size: 11px
		font-weight: 500

	.status-unavailable
		color: $v2-text-muted
		font-size: 11px

	// ── Users list ───────────────────────
	.nice-users-list
		.nice-user-thumb
			border-radius: 12px
			border-color: $v2-border
			transition: all 0.15s

			&:hover
				box-shadow: $v2-shadow-hover

	// ── Select dropdowns ─────────────────
	.ni_select--button_dd
		min-height: auto !important
		padding: 0 !important
		border: none !important
		background: transparent !important

	.ni_select--select-row
		border-bottom-color: $v2-border

	.ni_select--options
		border-radius: 10px
		border: 1px solid $v2-border
		box-shadow: 0 8px 24px rgba(0,0,0,0.1)

	// ── Edit pencil buttons ──────────────
	.edit-button,
	.pencil-button
		opacity: 0
		transition: opacity 0.15s

	tr:hover .edit-button,
	tr:hover .pencil-button,
	.details-header:hover .edit-button
		opacity: 1

	// ── Inline edit inputs ────────────────
	input[type="number"],
	input[type="text"]
		font-family: $v2-font
		border-radius: 8px
		border: 1px solid rgba($v2-teal, 0.4) !important
		font-size: 13px
		padding: 4px 8px

		&:focus
			outline: none
			box-shadow: 0 0 0 3px rgba($v2-teal, 0.1)

	// ── Buttons inside cards ─────────────
	.nice-button
		font-family: $v2-font !important

	// ── Responsive ───────────────────────
	@media (max-width: 768px)
		.details-header
			flex-direction: column !important
			align-items: flex-start !important

		table
			display: block
			overflow-x: auto
</style>
